import { render, staticRenderFns } from "./SettingCard.vue?vue&type=template&id=250ef446&scoped=true"
import script from "./SettingCard.vue?vue&type=script&lang=js"
export * from "./SettingCard.vue?vue&type=script&lang=js"
import style0 from "./SettingCard.vue?vue&type=style&index=0&id=250ef446&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "250ef446",
  null
  
)

export default component.exports